import {
  DeleteOutlined,
  EditOutlined,
  LinkOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';
import { Button, Form, Spin, Tooltip, message } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import GenerarEnlaceModal from '../../../components/GenerarEnlaceModal';
import SelectableListModal from '../../../components/SelectableListModal';
import TableAndFilters from '../../../components/TableAndFilters';
import { errorHandler } from '../../../utils';
import { instanceRef } from '../../../utils/axios';
import { fieldTypes, filterConditions } from '../../../utils/filter-utils';

const UsuarioEnlace = () => {
  const {
    params: { idCanal, idEnlace, idEmpresa }
  } = useRouteMatch();

  const tableRef = useRef();
  const [loading, setLoading] = useState(false);
  // const [editData, setEditData] = useState(null);
  const [canalInfo, setCanalInfo] = useState({});
  const [enlacePadre, setEnlacePadre] = useState({});
  const [isModalEnlaceOpen, setIsModalEnlaceOpen] = useState(false);
  const [usuarioEnlace, setUsuarioEnlace] = useState();
  const [idEnlaceUsuarioToUpdate, setIdEnlaceUsuarioToUpdate] = useState();

  const [enlaceForm] = Form.useForm();

  const getEnlacePadre = useCallback(async () => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(`/enlace/${idEnlace}`);
      setEnlacePadre(response.data?.data);
    } catch (error) {
      message.error('Error al obtener Enlace Padre');
    } finally {
      setLoading(false);
    }
  }, [idEnlace]);

  const getCanal = useCallback(async () => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(`/canal/${idCanal}`);
      setCanalInfo(response.data?.data);
    } catch (error) {
      message.error('Error al obtener canal');
    } finally {
      setLoading(false);
    }
  }, [idCanal]);

  const handleAsignarUsuarios = async (value) => {
    setLoading(true);
    try {
      const idUsuarios = value;
      const response = await instanceRef.instance.post('enlace/usuarios', {
        enlacePadre,
        idUsuarios
      });
      tableRef.current.reload();
      return response.data?.data;
    } catch (error) {
      errorHandler(error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const generarEnlaceCorto = (record) => {
    setIsModalEnlaceOpen(true);
    setUsuarioEnlace(record.usuario);
    setIdEnlaceUsuarioToUpdate(record.id);
  };

  useEffect(() => {
    if (idCanal && idEnlace) {
      getCanal();
      // getUsuariosAgregados();
      getEnlacePadre();
    }
  }, [idCanal, idEnlace, getCanal, getEnlacePadre]);

  const columns = [
    { title: 'Id', dataIndex: 'id', key: 'id' },
    {
      title: 'Producto',
      dataIndex: ['producto', 'descripcion'],
      key: 'producto'
    },
    {
      title: 'Nombres',
      dataIndex: ['usuario', 'nombres'],
      key: ['usuario', 'nombres']
    },
    {
      title: 'Celular',
      dataIndex: ['usuario', 'celular'],
      key: ['usuario', 'celular']
    },
    {
      title: 'Campaña',
      dataIndex: 'campanha',
      key: 'campanha'
    },
    {
      title: 'Enlace original',
      dataIndex: 'enlace_original',
      key: 'enlace_original'
    },
    {
      title: 'Enlace corto',
      dataIndex: 'enlace_corto',
      key: 'enlace_corto'
    },

    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => (
        <>
          <Tooltip title="Editar" key={record.id}>
            <Button
              disabled
              type="text"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => {}}
            />
          </Tooltip>

          <Tooltip title="Generar Enlace Corto" key={`enlace${record.id}`}>
            <Button
              type="text"
              icon={<LinkOutlined />}
              size="middle"
              onClick={() => generarEnlaceCorto(record)}
              disabled={record.enlace_corto}
            />
          </Tooltip>
          <Tooltip title="Eliminar enlace" key={record.id}>
            <Button
              disabled
              type="text"
              icon={<DeleteOutlined />}
              size="middle"
              onClick={() => {}}
            />
          </Tooltip>
        </>
      )
    }
  ];

  const columnsUsuario = [
    { title: 'Id', dataIndex: 'id', key: 'id' },
    {
      title: 'Nombres',
      dataIndex: 'nombres',
      key: 'nombres'
    },
    {
      title: 'Usuario',
      dataIndex: 'usuario',
      key: 'usuario'
    },
    {
      title: 'Celular',
      dataIndex: 'celular',
      key: 'celular'
    },
    {
      title: 'Correo',
      dataIndex: 'correo',
      key: 'correo'
    },
    {
      title: 'CI',
      dataIndex: 'cedula',
      key: 'cedula'
    }
  ];

  return (
    <Spin spinning={loading} size="large" tip="Cargando...">
      <TableAndFilters
        ref={tableRef}
        withGeneralFilter
        url="/enlace/canal"
        title={`
           Gestión de enlaces para usuarios | ${canalInfo?.descripcion}`}
        columns={columns}
        defaultFilters={{
          id_canal: {
            value: idCanal,
            filterType: fieldTypes.NUMERIC,
            filterCondition: filterConditions.EQUALS
          },
          id_enlace: {
            value: idEnlace,
            filterType: fieldTypes.NUMERIC,
            filterCondition: filterConditions.EQUALS
          }
        }}
        showTable
        hasExportar
        extra={[
          <SelectableListModal
            isMultiple
            title="Asignar Usuarios"
            placeholder="Buscar usuarios"
            width={1000}
            resetValue
            notNull
            columnsData={columnsUsuario}
            url={`/usuarios/enlace?id_enlace_padre=${idEnlace}`}
            setNewList={(value) => {
              handleAsignarUsuarios(value);
            }}
            defaultFilters={{
              id_sucursal: {
                value: canalInfo?.id_sucursal || 0,
                filterType: fieldTypes.NUMERIC,
                filterCondition: filterConditions.EQUALS
              }
            }}
            button={
              <Button
                key="enlaceUsuarioAdd"
                type="dashed"
                shape="round"
                icon={<PlusCircleOutlined />}
                size="middle"
              >
                Agregar Enlace Usuario
              </Button>
            }
          />
        ]}
      />
      <GenerarEnlaceModal
        form={enlaceForm}
        idEmpresa={idEmpresa}
        isModalOpen={isModalEnlaceOpen}
        setIsModalOpen={setIsModalEnlaceOpen}
        canalEnlace={canalInfo}
        usuarioEnlace={usuarioEnlace}
        idEnlace={idEnlace}
        enlacePadre={enlacePadre}
        idEnlaceUsuarioToUpdate={idEnlaceUsuarioToUpdate}
      />
    </Spin>
  );
};

export default UsuarioEnlace;
